/* eslint-disable */
/* !!! THIS FILE WAS GENERATED BY GRAPHQL-CODE-GENERATOR !!!
* !!! DO NOT MODIFY THIS FILE BY YOURSELF  !!! */

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateScalar: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  ShopifyOrderID: { input: string; output: string; }
  ShopifyProductID: { input: string; output: string; }
  ShopifyProductVariantID: { input: string; output: string; }
};

export type Affiliate = {
  __typename?: 'Affiliate';
  affiliateCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type BaseCommissionPolicy = {
  /** The commission percentage for the policy */
  commissionPercentage: Scalars['Int']['output'];
  /** The unique ID of the commission policy */
  id: Scalars['ID']['output'];
};

/** Checkout LineItems */
export type CheckoutLineItem = {
  __typename?: 'CheckoutLineItem';
  fulfillmentService?: Maybe<Scalars['String']['output']>;
  grams?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  linePrice?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['Float']['output']>;
  quantity: Scalars['Int']['output'];
  requiresShipping?: Maybe<Scalars['Boolean']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  taxable?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  variantId: Scalars['Float']['output'];
  variantTitle?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
};

export enum Client {
  Android = 'android',
  Ios = 'ios',
  Web = 'web'
}

export type Collection = {
  __typename?: 'Collection';
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  products: ProductConnection;
  productsCount: Scalars['Int']['output'];
  publishedOnCurrentPublication: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};


export type CollectionProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollectionConnection = {
  __typename?: 'CollectionConnection';
  edges: Array<CollectionEdge>;
  pageInfo: PageInfo;
};

export type CollectionEdge = {
  __typename?: 'CollectionEdge';
  cursor: Scalars['String']['output'];
  node: Collection;
};

export type CommissionPolicy = BaseCommissionPolicy & {
  __typename?: 'CommissionPolicy';
  /** The commission percentage for the policy */
  commissionPercentage: Scalars['Int']['output'];
  /** The unique ID of the commission policy */
  id: Scalars['ID']['output'];
};

/** Represent a Connection to a STAGE TEN account */
export type Connection = {
  __typename?: 'Connection';
  /** @deprecated No longer used */
  accountId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Replaced with Shop.channelId */
  channelId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['DateScalar']['output']>;
  /** @deprecated No longer used */
  id?: Maybe<Scalars['ID']['output']>;
  /** @deprecated No longer used */
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer used */
  shopId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['DateScalar']['output']>;
  /** @deprecated No longer used */
  userId?: Maybe<Scalars['ID']['output']>;
};

export type ConnectionRequestResponse = {
  __typename?: 'ConnectionRequestResponse';
  hasExistingConnection: Scalars['Boolean']['output'];
};

export type CreateSaleInput = {
  collectionIds: Array<Scalars['String']['input']>;
  /** A discount code for the Sale */
  discountCode?: InputMaybe<Scalars['String']['input']>;
  productIds: Array<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CustomCommissionPolicy = BaseCommissionPolicy & {
  __typename?: 'CustomCommissionPolicy';
  /** The commission percentage for the policy */
  commissionPercentage: Scalars['Int']['output'];
  /** The date when the custom commission policy was created */
  createdAt: Scalars['DateTime']['output'];
  /** A brief description of the custom commission policy */
  description?: Maybe<Scalars['String']['output']>;
  /** The date at which the custom commission policy will expire */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** The unique ID of the custom commission policy */
  id: Scalars['ID']['output'];
  /** The shop associated with the custom commission policy */
  shop: Shop;
  /** The date when the custom commission policy was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

export type Discount = {
  __typename?: 'Discount';
  /** The discount code */
  code: Scalars['String']['output'];
  /** Whether the discount code exists */
  exists: Scalars['Boolean']['output'];
  /** Information about the discount */
  info?: Maybe<DiscountInfo>;
};

export type DiscountExpiredWarning = DiscountWarning & {
  __typename?: 'DiscountExpiredWarning';
  /** The code associated with the warning */
  code: DiscountWarningCode;
  /** The date and time when the discount expired */
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  /** A description of the warning */
  message: Scalars['String']['output'];
};

export type DiscountInfo = {
  __typename?: 'DiscountInfo';
  /** The date and time when the discount ends */
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  /** The URL of the discount within the Shopify admin */
  shopifyAdminUrl: Scalars['String']['output'];
  /** A short summary of the discount */
  shortSummary: Scalars['String']['output'];
  /** The date and time when the discount starts */
  startsAt: Scalars['DateTime']['output'];
  /** The status of the discount */
  status: DiscountStatus;
  /** A summary of the discount */
  summary: Scalars['String']['output'];
  /** Warnings about the discount */
  warnings: Array<DiscountWarning>;
};

export type DiscountNonApplicableWarning = DiscountWarning & {
  __typename?: 'DiscountNonApplicableWarning';
  /** The code associated with the warning */
  code: DiscountWarningCode;
  /** A description of the warning */
  message: Scalars['String']['output'];
  /** The product IDs in a Sale which aren't applicable for the discount */
  nonApplicableProductIds: Array<Scalars['String']['output']>;
};

/** The status of the discount */
export enum DiscountStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Scheduled = 'SCHEDULED'
}

export type DiscountWarning = {
  /** The code associated with the warning */
  code: DiscountWarningCode;
  /** A description of the warning */
  message: Scalars['String']['output'];
};

/** The code associated with the warning */
export enum DiscountWarningCode {
  Expired = 'EXPIRED',
  NonApplicable = 'NON_APPLICABLE'
}

/** Whether a given resource is eligible for Shop Mini */
export enum EligibilityStatus {
  Eligible = 'ELIGIBLE',
  Ineligible = 'INELIGIBLE'
}

export type Image = {
  __typename?: 'Image';
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  originalSrc: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type ImageConnection = {
  __typename?: 'ImageConnection';
  edges: Array<ImageEdge>;
};

export type ImageEdge = {
  __typename?: 'ImageEdge';
  node: Image;
};

export type LineItem = {
  __typename?: 'LineItem';
  id: Scalars['String']['output'];
  product?: Maybe<Product>;
  quantity: Scalars['Int']['output'];
  variant?: Maybe<ProductVariant>;
};

export type MoneyV2 = {
  __typename?: 'MoneyV2';
  amount: Scalars['String']['output'];
  currencyCode: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  activateSale: Shop;
  /** @deprecated Completed checkouts are now detected using webhooks */
  checkoutCompleted: Scalars['Boolean']['output'];
  clearFeaturedItem: Sale;
  /** @deprecated Replaced with createConnectionRequestV2 */
  createConnectionRequest: ConnectionRequestResponse;
  createConnectionRequestV2: ConnectionRequestResponse;
  createSale: Sale;
  deactivateSale: Shop;
  /** @deprecated Temporary endpoint for initial development */
  deleteAllSalesOnShop: Shop;
  /** @deprecated Replaced with deleteConnectionV2 which resolves a Shop */
  deleteConnection: Scalars['Boolean']['output'];
  deleteConnectionV2?: Maybe<Shop>;
  /** Deletes the custom commission policy for a shop */
  deleteCustomCommissionPolicyForShop: Shop;
  deleteSale: Sale;
  featureCollection: Sale;
  featureProduct: Sale;
  productsAddedToCart: Scalars['Boolean']['output'];
  /** Sets whether the Shop Mini entrypoint should be hidden when the broadcast on the associated output is ended */
  setHideShopMiniEntrypointOnBroadcastEnd: Shop;
  setOnboardingState: Shop;
  /** Sets the internal enabled/disabled state of the Shop Mini */
  setShopMiniEnabled: Shop;
  /** Sets whether Shop Mini push notifications should be triggered when a broadcast is started */
  setShopMiniPushNotificationsEnabled: Shop;
  updateCollectionVisibility: Sale;
  updateProductVisibility: Sale;
  updateSale: Sale;
  /** Updates properties of the Event Card entrypoint for Shop Mini */
  updateShopMiniEntrypoint: Shop;
  updateShopPreferences: Shop;
  /** Upserts the custom commission policy for a shop */
  upsertCustomCommissionPolicyForShop: Shop;
};


export type MutationActivateSaleArgs = {
  saleId: Scalars['ID']['input'];
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCheckoutCompletedArgs = {
  orderId: Scalars['ShopifyOrderID']['input'];
  saleId: Scalars['ID']['input'];
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationClearFeaturedItemArgs = {
  saleId: Scalars['ID']['input'];
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateConnectionRequestArgs = {
  channelId: Scalars['String']['input'];
  shopDomain: Scalars['String']['input'];
};


export type MutationCreateConnectionRequestV2Args = {
  shopDomain: Scalars['String']['input'];
};


export type MutationCreateSaleArgs = {
  sale: CreateSaleInput;
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeactivateSaleArgs = {
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteAllSalesOnShopArgs = {
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteConnectionArgs = {
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteConnectionV2Args = {
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteCustomCommissionPolicyForShopArgs = {
  shopDomain: Scalars['String']['input'];
};


export type MutationDeleteSaleArgs = {
  saleId: Scalars['ID']['input'];
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationFeatureCollectionArgs = {
  collectionId: Scalars['String']['input'];
  saleId: Scalars['ID']['input'];
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationFeatureProductArgs = {
  productId: Scalars['String']['input'];
  saleId: Scalars['ID']['input'];
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationProductsAddedToCartArgs = {
  productId: Scalars['ShopifyProductID']['input'];
  quantity: Scalars['Int']['input'];
  saleId: Scalars['ID']['input'];
  shopId?: InputMaybe<Scalars['ID']['input']>;
  variantId: Scalars['ShopifyProductVariantID']['input'];
};


export type MutationSetHideShopMiniEntrypointOnBroadcastEndArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationSetOnboardingStateArgs = {
  onboardingState: OnboardingStateInput;
};


export type MutationSetShopMiniEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationSetShopMiniPushNotificationsEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationUpdateCollectionVisibilityArgs = {
  collectionId: Scalars['String']['input'];
  saleId: Scalars['ID']['input'];
  shopId?: InputMaybe<Scalars['ID']['input']>;
  visible: Scalars['Boolean']['input'];
};


export type MutationUpdateProductVisibilityArgs = {
  productId: Scalars['String']['input'];
  saleId: Scalars['ID']['input'];
  shopId?: InputMaybe<Scalars['ID']['input']>;
  visible: Scalars['Boolean']['input'];
};


export type MutationUpdateSaleArgs = {
  sale: UpdateSaleInput;
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateShopMiniEntrypointArgs = {
  activeBackgroundImage?: InputMaybe<Scalars['String']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  preActiveBackgroundImage?: InputMaybe<Scalars['String']['input']>;
  preActivePrimaryText?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationUpdateShopPreferencesArgs = {
  preferences: UpdateShopPreferencesInput;
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpsertCustomCommissionPolicyForShopArgs = {
  customCommissionPolicy: UpsertCustomCommissionPolicyInput;
  shopDomain: Scalars['String']['input'];
};

/** Set the onboarding state */
export type OnboardingStateInput = {
  onboardingCompleted: Scalars['Boolean']['input'];
  shopId: Scalars['ID']['input'];
};

export type Order = {
  __typename?: 'Order';
  baseCurrencyCode: Scalars['String']['output'];
  baseDiscountApplied: Scalars['String']['output'];
  baseSubtotal: Scalars['String']['output'];
  baseSubtotalWithoutDiscount: Scalars['String']['output'];
  baseTotal: Scalars['String']['output'];
  cartId: Scalars['ID']['output'];
  commissionPercentage: Scalars['Float']['output'];
  currencyCode: Scalars['String']['output'];
  discountApplied: Scalars['String']['output'];
  discountCode?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced with Order.lineItems */
  items: Array<CheckoutLineItem>;
  lineItems: Array<LineItem>;
  name: Scalars['String']['output'];
  nameIsProfane: Scalars['Boolean']['output'];
  orderId: Scalars['ShopifyOrderID']['output'];
  processedAt: Scalars['DateTime']['output'];
  saleId: Scalars['ID']['output'];
  shopId: Scalars['ID']['output'];
  subtotal: Scalars['String']['output'];
  subtotalWithoutDiscount: Scalars['String']['output'];
  total: Scalars['String']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
};

export type PaginatedSaleResponse = {
  __typename?: 'PaginatedSaleResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<Sale>;
};

export type PrimaryDomain = {
  __typename?: 'PrimaryDomain';
  host: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Product = {
  __typename?: 'Product';
  featuredImage?: Maybe<Image>;
  id: Scalars['String']['output'];
  images: ImageConnection;
  options: Array<ProductOption>;
  priceRangeV2: ProductPriceRangeV2;
  publishedOnCurrentPublication: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  totalInventory: Scalars['Int']['output'];
  tracksInventory: Scalars['Boolean']['output'];
  variants: ProductVariantConnection;
};


export type ProductImagesArgs = {
  first: Scalars['Int']['input'];
};

export type ProductConnection = {
  __typename?: 'ProductConnection';
  edges: Array<ProductEdge>;
  pageInfo: PageInfo;
};

export type ProductEdge = {
  __typename?: 'ProductEdge';
  cursor: Scalars['String']['output'];
  node: Product;
};

export type ProductEligibility = {
  __typename?: 'ProductEligibility';
  productId: Scalars['ShopifyProductID']['output'];
  status: EligibilityStatus;
};

export type ProductOption = {
  __typename?: 'ProductOption';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  values: Array<Scalars['String']['output']>;
};

export type ProductPriceRangeV2 = {
  __typename?: 'ProductPriceRangeV2';
  maxVariantPrice: MoneyV2;
  minVariantPrice: MoneyV2;
};

export enum ProductSortKeys {
  Id = 'ID',
  Title = 'TITLE'
}

export type ProductVariant = {
  __typename?: 'ProductVariant';
  availableForSale: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  inventoryQuantity?: Maybe<Scalars['Int']['output']>;
  price: Scalars['String']['output'];
  selectedOptions: Array<SelectedOptions>;
  title: Scalars['String']['output'];
};

export type ProductVariantConnection = {
  __typename?: 'ProductVariantConnection';
  edges: Array<ProductVariantEdge>;
  pageInfo: PageInfo;
};

export type ProductVariantEdge = {
  __typename?: 'ProductVariantEdge';
  cursor: Scalars['String']['output'];
  node: ProductVariant;
};

export type PurchaseFeedbackPreferences = {
  __typename?: 'PurchaseFeedbackPreferences';
  enabled: Scalars['Boolean']['output'];
};

export type Query = {
  __typename?: 'Query';
  collections: CollectionConnection;
  /** @deprecated This can be replaced with a shopByDomain query */
  connectionByShopDomain?: Maybe<Connection>;
  /** Information about a discount by its code */
  discount: Discount;
  /** Retrieve a list of custom commission policies */
  listCustomCommissionPolicies: Array<CustomCommissionPolicy>;
  product?: Maybe<Product>;
  products: ProductConnection;
  /** Returns a list of public recording IDs on a Shop */
  recordingIdsByShopDomain: Array<Scalars['ID']['output']>;
  sale?: Maybe<Sale>;
  saleForRecording?: Maybe<Sale>;
  sales?: Maybe<PaginatedSaleResponse>;
  shop?: Maybe<Shop>;
  shopByChannelId?: Maybe<Shop>;
  shopByDomain?: Maybe<Shop>;
  /** Determines whether products products are eligible to be sold on Shop Mini */
  shopMiniProductEligibilities: Array<ProductEligibility>;
};


export type QueryCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryConnectionByShopDomainArgs = {
  shopDomain: Scalars['String']['input'];
};


export type QueryDiscountArgs = {
  code: Scalars['String']['input'];
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<ProductSortKeys>;
};


export type QueryRecordingIdsByShopDomainArgs = {
  shopDomain: Scalars['String']['input'];
};


export type QuerySaleArgs = {
  saleId: Scalars['ID']['input'];
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySaleForRecordingArgs = {
  recordingId: Scalars['ID']['input'];
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySalesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryShopArgs = {
  shopId: Scalars['ID']['input'];
};


export type QueryShopByChannelIdArgs = {
  channelId: Scalars['ID']['input'];
};


export type QueryShopByDomainArgs = {
  shopDomain: Scalars['String']['input'];
};


export type QueryShopMiniProductEligibilitiesArgs = {
  productIds: Array<Scalars['ShopifyProductID']['input']>;
};

export type RecurringApplicationCharge = {
  __typename?: 'RecurringApplicationCharge';
  billingOn?: Maybe<Scalars['String']['output']>;
  cappedAmount?: Maybe<Scalars['Float']['output']>;
};

export type ReturnToShowSignal = {
  __typename?: 'ReturnToShowSignal';
  id: Scalars['String']['output'];
};

export type Sale = {
  __typename?: 'Sale';
  /** The ID of the associated Channel */
  channelId: Scalars['ID']['output'];
  /** Which client this Sale belongs to */
  client: Client;
  /** The collections belonging to the Sale */
  collectionIds: Array<Scalars['String']['output']>;
  collections: Array<Collection>;
  createdAt: Scalars['DateTime']['output'];
  /** A brief description of the sale, used for the overlay asset */
  details?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Discount>;
  /** The user-defined discount code associated with the Sale */
  discountCode?: Maybe<Scalars['String']['output']>;
  /**
   * The discount type of the Sale
   * @deprecated Sales no longer hold specific details about discounts
   */
  discountType?: Maybe<SaleDiscount>;
  /**
   * The value of the discount, if applicable
   * @deprecated Sales no longer hold specific details about discounts
   */
  discountValue?: Maybe<Scalars['Float']['output']>;
  /** The currently featured collection */
  featuredCollectionId?: Maybe<Scalars['String']['output']>;
  /** The currently featured product */
  featuredProductId?: Maybe<Scalars['String']['output']>;
  /** Indicates if the Sale is hidden */
  hidden: Scalars['Boolean']['output'];
  /** The ID of the Sale */
  id: Scalars['ID']['output'];
  /** Returns the featured image of the first product in the sale */
  previewImage?: Maybe<Image>;
  /** The products belonging to the Sale */
  productIds: Array<Scalars['String']['output']>;
  products: Array<Product>;
  /** The ID of the associated Shop */
  shopId: Scalars['ID']['output'];
  /** Product IDs which are eligible to be sold via Shop Mini */
  shopMiniEligibleProductIds: Array<Scalars['ShopifyProductID']['output']>;
  /** The internal title of the Sale */
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** The subset of collections which are visible to viewers */
  visibleCollectionIds: Array<Scalars['String']['output']>;
  /** The subset of products which are visible to viewers */
  visibleProductIds: Array<Scalars['String']['output']>;
};


export type SaleCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type SaleProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};

export enum SaleDiscount {
  FixedAmount = 'fixedAmount',
  FreeShipping = 'freeShipping',
  None = 'none',
  Percentage = 'percentage'
}

export type SaleEvent = {
  __typename?: 'SaleEvent';
  /** The ID of the event */
  id: Scalars['ID']['output'];
  /** The Sale associated with the event */
  sale: Sale;
  /** The type of the event */
  type: SaleEventType;
};

export enum SaleEventType {
  SaleCreated = 'SALE_CREATED',
  SaleDeleted = 'SALE_DELETED',
  SaleUpdated = 'SALE_UPDATED'
}

export type SelectedOptions = {
  __typename?: 'SelectedOptions';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Represents a Shopify store */
export type Shop = {
  __typename?: 'Shop';
  activeSale?: Maybe<Sale>;
  activeSaleId?: Maybe<Scalars['ID']['output']>;
  /** The affiliate associated with a channel currently connected to the shop */
  affiliate?: Maybe<Affiliate>;
  appHandle: Scalars['String']['output'];
  /** The URL of the App's home page */
  appUrl?: Maybe<Scalars['String']['output']>;
  availableProductCount: Scalars['Int']['output'];
  channelId?: Maybe<Scalars['ID']['output']>;
  connected: Scalars['Boolean']['output'];
  /** @deprecated Replaced with Shop.channelId and Shop.connected */
  connection?: Maybe<Connection>;
  createdAt?: Maybe<Scalars['DateScalar']['output']>;
  /** @deprecated Replaced with Shop.shopDetails.currencyCode */
  currencyCode?: Maybe<Scalars['String']['output']>;
  /** Represents the current commission policy */
  currentCommissionPolicy: CommissionPolicy;
  /** Represents the custom commission policy (if one exists) */
  customCommissionPolicy?: Maybe<CustomCommissionPolicy>;
  /** Represents the default commission policy */
  defaultCommissionPolicy: CommissionPolicy;
  /** The broadcast-viewer embed URL of the channel */
  embedUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isShopOwner: Scalars['Boolean']['output'];
  needsReauthorization: Scalars['Boolean']['output'];
  onboardingCompleted?: Maybe<Scalars['Boolean']['output']>;
  preferences: ShopPreferences;
  publicationId: Scalars['String']['output'];
  recurringApplicationCharge?: Maybe<RecurringApplicationCharge>;
  saleCount: Scalars['Int']['output'];
  sales: PaginatedSaleResponse;
  shopDetails: ShopDetails;
  shopDomain: Scalars['String']['output'];
  /** State related to the Shop Mini */
  shopMini: ShopMini;
  storefrontAccessToken?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateScalar']['output']>;
  watchUrl?: Maybe<Scalars['String']['output']>;
};


/** Represents a Shopify store */
export type ShopSalesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};

export type ShopDetails = {
  __typename?: 'ShopDetails';
  checkoutApiSupported: Scalars['Boolean']['output'];
  contactEmail: Scalars['String']['output'];
  currencyCode: Scalars['String']['output'];
  email: Scalars['String']['output'];
  myshopifyDomain: Scalars['String']['output'];
  name: Scalars['String']['output'];
  primaryDomain: PrimaryDomain;
};

export type ShopMini = {
  __typename?: 'ShopMini';
  /** State related to the Shop Mini entrypoint */
  entrypoint: ShopMiniEntrypoint;
  /** Whether this shop is eligible for Shop Mini */
  isEligible: Scalars['Boolean']['output'];
  /** Whether the shop has enabled Shop Mini */
  isEnabled: Scalars['Boolean']['output'];
  shop: Shop;
};

export type ShopMiniEntrypoint = {
  __typename?: 'ShopMiniEntrypoint';
  /** The background image of the Shop Mini entrypoint while in the provided status */
  backgroundImage?: Maybe<Image>;
  /** Whether the entrypoint should be automatically hidden when a broadcast is ended */
  hideOnBroadcastEnd: Scalars['Boolean']['output'];
  /** Whether the Shop Mini entrypoint is visible within the Shop app */
  isVisible: Scalars['Boolean']['output'];
  /** The primary text of the Shop Mini entrypoint while in the provided status */
  primaryText?: Maybe<Scalars['String']['output']>;
  /** Whether push notifications should be triggered when a broadcast is started */
  pushNotificationsEnabled: Scalars['Boolean']['output'];
  shop: Shop;
  /** The event date and time of the Shop Mini with respect to broadcast lifecycle */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** The status of the Shop Mini with respect to broadcast lifecycle */
  status: ShopMiniState;
};


export type ShopMiniEntrypointBackgroundImageArgs = {
  status: ShopMiniState;
};


export type ShopMiniEntrypointPrimaryTextArgs = {
  status: ShopMiniState;
};

/** The state of the Shop Mini with respect to broadcast lifecycle */
export enum ShopMiniState {
  Active = 'ACTIVE',
  PostActive = 'POST_ACTIVE',
  PreActive = 'PRE_ACTIVE'
}

export type ShopPreferences = {
  __typename?: 'ShopPreferences';
  /** Whether the player should force checkouts to be completed with Shopify's native checkout flow. */
  forceShopifyCheckout: Scalars['Boolean']['output'];
  purchaseFeedback: PurchaseFeedbackPreferences;
  shoutouts: ShoutoutsPreferences;
};

export type ShoutoutsPreferences = {
  __typename?: 'ShoutoutsPreferences';
  enabled: Scalars['Boolean']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  /** Emits when attributes of the Shop's active sale have been updated */
  activeSaleUpdated: Sale;
  /** Emits when an order has been created for the given cart */
  orderCreatedForCart: Order;
  /** Emits when an order has been completed through Stage TEN Commerce */
  orderCreatedOnShop: Order;
  /** Emits when a Shop's active sale has changed (ie. Activated or deactivated) */
  saleActivatedOrDeactivated: Shop;
  /** A sale has been created, updated or deleted */
  saleEvent: SaleEvent;
  /** Emits when a Stage TEN channel's connection has been updated (ie. Shop connected or disconnected) */
  shopConnectionForChannelUpdated?: Maybe<Shop>;
  /** Emits when a Shop's connection has been updated (ie. Channel connected or disconnected) */
  shopConnectionUpdated: Shop;
  /** Emits when a Shop's Shop Mini Entrypoint has been updated */
  shopMiniEntrypointUpdated: Shop;
  /** Emits when a viewer clicks the return to show button */
  viewerSignalledReturnToShow: ReturnToShowSignal;
};


export type SubscriptionActiveSaleUpdatedArgs = {
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionOrderCreatedForCartArgs = {
  cartIds: Array<Scalars['ID']['input']>;
};


export type SubscriptionOrderCreatedOnShopArgs = {
  shopId: Scalars['ID']['input'];
};


export type SubscriptionSaleActivatedOrDeactivatedArgs = {
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionShopConnectionForChannelUpdatedArgs = {
  channelId?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionShopMiniEntrypointUpdatedArgs = {
  shopId: Scalars['ID']['input'];
};


export type SubscriptionViewerSignalledReturnToShowArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type UpdatePurchaseFeedbackPreferencesInput = {
  enabled: Scalars['Boolean']['input'];
};

export type UpdateSaleInput = {
  collectionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  details?: InputMaybe<Scalars['String']['input']>;
  /** The discount code for the Sale */
  discountCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  productIds?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateShopPreferencesInput = {
  forceShopifyCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  purchaseFeedback?: InputMaybe<UpdatePurchaseFeedbackPreferencesInput>;
  shoutouts?: InputMaybe<UpdateShoutoutsPreferencesInput>;
};

export type UpdateShoutoutsPreferencesInput = {
  enabled: Scalars['Boolean']['input'];
};

export type UpsertCustomCommissionPolicyInput = {
  /** The commission percentage for the policy */
  commissionPercentage: Scalars['Int']['input'];
  /** A brief description of the custom commission policy */
  description: Scalars['String']['input'];
  /** The date at which the custom commission policy will expire */
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SaleFieldsFragment = { __typename?: 'Sale', id: string, discountCode?: string | null, discountValue?: number | null, discountType?: SaleDiscount | null, featuredProductId?: string | null, featuredCollectionId?: string | null, visibleProductIds: Array<string>, visibleCollectionIds: Array<string> };

export type ShopFieldsFragment = { __typename?: 'Shop', id: string, shopDomain: string, channelId?: string | null, activeSaleId?: string | null, storefrontAccessToken?: string | null, activeSale?: { __typename?: 'Sale', id: string, discountCode?: string | null, discountValue?: number | null, discountType?: SaleDiscount | null, featuredProductId?: string | null, featuredCollectionId?: string | null, visibleProductIds: Array<string>, visibleCollectionIds: Array<string> } | null, preferences: { __typename?: 'ShopPreferences', forceShopifyCheckout: boolean, purchaseFeedback: { __typename?: 'PurchaseFeedbackPreferences', enabled: boolean } } };

export type GetShopByChannelIdQueryVariables = Exact<{
  channelId: Scalars['ID']['input'];
}>;


export type GetShopByChannelIdQuery = { __typename?: 'Query', shopByChannelId?: { __typename?: 'Shop', id: string, shopDomain: string, channelId?: string | null, activeSaleId?: string | null, storefrontAccessToken?: string | null, activeSale?: { __typename?: 'Sale', id: string, discountCode?: string | null, discountValue?: number | null, discountType?: SaleDiscount | null, featuredProductId?: string | null, featuredCollectionId?: string | null, visibleProductIds: Array<string>, visibleCollectionIds: Array<string> } | null, preferences: { __typename?: 'ShopPreferences', forceShopifyCheckout: boolean, purchaseFeedback: { __typename?: 'PurchaseFeedbackPreferences', enabled: boolean } } } | null };

export type GetShopByShopDomainQueryVariables = Exact<{
  shopDomain: Scalars['String']['input'];
}>;


export type GetShopByShopDomainQuery = { __typename?: 'Query', shopByDomain?: { __typename?: 'Shop', id: string, shopDomain: string, channelId?: string | null, activeSaleId?: string | null, storefrontAccessToken?: string | null, activeSale?: { __typename?: 'Sale', id: string, discountCode?: string | null, discountValue?: number | null, discountType?: SaleDiscount | null, featuredProductId?: string | null, featuredCollectionId?: string | null, visibleProductIds: Array<string>, visibleCollectionIds: Array<string> } | null, preferences: { __typename?: 'ShopPreferences', forceShopifyCheckout: boolean, purchaseFeedback: { __typename?: 'PurchaseFeedbackPreferences', enabled: boolean } } } | null };

export type GetShopPreferencesQueryVariables = Exact<{
  channelId: Scalars['ID']['input'];
}>;


export type GetShopPreferencesQuery = { __typename?: 'Query', shopByChannelId?: { __typename?: 'Shop', preferences: { __typename?: 'ShopPreferences', forceShopifyCheckout: boolean, purchaseFeedback: { __typename?: 'PurchaseFeedbackPreferences', enabled: boolean } } } | null };

export type CheckoutCompletedMutationVariables = Exact<{
  shopId: Scalars['ID']['input'];
  saleId: Scalars['ID']['input'];
  orderId: Scalars['ShopifyOrderID']['input'];
}>;


export type CheckoutCompletedMutation = { __typename?: 'Mutation', checkoutCompleted: boolean };

export type TrackCartUpdateMutationVariables = Exact<{
  shopId: Scalars['ID']['input'];
  saleId: Scalars['ID']['input'];
  productId: Scalars['ShopifyProductID']['input'];
  variantId: Scalars['ShopifyProductVariantID']['input'];
  quantity: Scalars['Int']['input'];
}>;


export type TrackCartUpdateMutation = { __typename?: 'Mutation', trackCartUpdate: boolean };

export type ActiveSaleUpdatedSubscriptionVariables = Exact<{
  shopId: Scalars['ID']['input'];
}>;


export type ActiveSaleUpdatedSubscription = { __typename?: 'Subscription', activeSaleUpdated: { __typename?: 'Sale', id: string, discountCode?: string | null, discountValue?: number | null, discountType?: SaleDiscount | null, featuredProductId?: string | null, featuredCollectionId?: string | null, visibleProductIds: Array<string>, visibleCollectionIds: Array<string> } };

export type SaleActivatedOrDeactivatedSubscriptionVariables = Exact<{
  shopId: Scalars['ID']['input'];
}>;


export type SaleActivatedOrDeactivatedSubscription = { __typename?: 'Subscription', saleActivatedOrDeactivated: { __typename?: 'Shop', id: string, shopDomain: string, channelId?: string | null, activeSaleId?: string | null, storefrontAccessToken?: string | null, activeSale?: { __typename?: 'Sale', id: string, discountCode?: string | null, discountValue?: number | null, discountType?: SaleDiscount | null, featuredProductId?: string | null, featuredCollectionId?: string | null, visibleProductIds: Array<string>, visibleCollectionIds: Array<string> } | null, preferences: { __typename?: 'ShopPreferences', forceShopifyCheckout: boolean, purchaseFeedback: { __typename?: 'PurchaseFeedbackPreferences', enabled: boolean } } } };

export type ShopConnectionForChannelUpdatedSubscriptionVariables = Exact<{
  channelId: Scalars['ID']['input'];
}>;


export type ShopConnectionForChannelUpdatedSubscription = { __typename?: 'Subscription', shopConnectionForChannelUpdated?: { __typename?: 'Shop', id: string, shopDomain: string, channelId?: string | null, activeSaleId?: string | null, storefrontAccessToken?: string | null, activeSale?: { __typename?: 'Sale', id: string, discountCode?: string | null, discountValue?: number | null, discountType?: SaleDiscount | null, featuredProductId?: string | null, featuredCollectionId?: string | null, visibleProductIds: Array<string>, visibleCollectionIds: Array<string> } | null, preferences: { __typename?: 'ShopPreferences', forceShopifyCheckout: boolean, purchaseFeedback: { __typename?: 'PurchaseFeedbackPreferences', enabled: boolean } } } | null };

export type OrderCreatedFieldsFragment = { __typename?: 'Order', cartId: string, orderId: string };

export type OrderCreatedForCartSubscriptionVariables = Exact<{
  cartIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type OrderCreatedForCartSubscription = { __typename?: 'Subscription', orderCreatedForCart: { __typename?: 'Order', cartId: string, orderId: string } };

export type ViewerSignalledReturnToShowSubscriptionVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ViewerSignalledReturnToShowSubscription = { __typename?: 'Subscription', viewerSignalledReturnToShow: { __typename?: 'ReturnToShowSignal', id: string } };

export const SaleFieldsFragmentDoc = gql`
    fragment SaleFields on Sale {
  id
  discountCode
  discountValue
  discountType
  featuredProductId
  featuredCollectionId
  visibleProductIds
  visibleCollectionIds
}
    `;
export const ShopFieldsFragmentDoc = gql`
    fragment ShopFields on Shop {
  id
  shopDomain
  channelId
  activeSale {
    ...SaleFields
  }
  activeSaleId
  storefrontAccessToken
  preferences {
    purchaseFeedback {
      enabled
    }
    forceShopifyCheckout
  }
}
    ${SaleFieldsFragmentDoc}`;
export const OrderCreatedFieldsFragmentDoc = gql`
    fragment OrderCreatedFields on Order {
  cartId
  orderId
}
    `;
export const GetShopByChannelIdDocument = gql`
    query getShopByChannelId($channelId: ID!) {
  shopByChannelId(channelId: $channelId) {
    ...ShopFields
  }
}
    ${ShopFieldsFragmentDoc}`;

/**
 * __useGetShopByChannelIdQuery__
 *
 * To run a query within a React component, call `useGetShopByChannelIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShopByChannelIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShopByChannelIdQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetShopByChannelIdQuery(baseOptions: Apollo.QueryHookOptions<GetShopByChannelIdQuery, GetShopByChannelIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShopByChannelIdQuery, GetShopByChannelIdQueryVariables>(GetShopByChannelIdDocument, options);
      }
export function useGetShopByChannelIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShopByChannelIdQuery, GetShopByChannelIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShopByChannelIdQuery, GetShopByChannelIdQueryVariables>(GetShopByChannelIdDocument, options);
        }
export function useGetShopByChannelIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetShopByChannelIdQuery, GetShopByChannelIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetShopByChannelIdQuery, GetShopByChannelIdQueryVariables>(GetShopByChannelIdDocument, options);
        }
export type GetShopByChannelIdQueryHookResult = ReturnType<typeof useGetShopByChannelIdQuery>;
export type GetShopByChannelIdLazyQueryHookResult = ReturnType<typeof useGetShopByChannelIdLazyQuery>;
export type GetShopByChannelIdSuspenseQueryHookResult = ReturnType<typeof useGetShopByChannelIdSuspenseQuery>;
export type GetShopByChannelIdQueryResult = Apollo.QueryResult<GetShopByChannelIdQuery, GetShopByChannelIdQueryVariables>;
export const GetShopByShopDomainDocument = gql`
    query getShopByShopDomain($shopDomain: String!) {
  shopByDomain(shopDomain: $shopDomain) {
    ...ShopFields
  }
}
    ${ShopFieldsFragmentDoc}`;

/**
 * __useGetShopByShopDomainQuery__
 *
 * To run a query within a React component, call `useGetShopByShopDomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShopByShopDomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShopByShopDomainQuery({
 *   variables: {
 *      shopDomain: // value for 'shopDomain'
 *   },
 * });
 */
export function useGetShopByShopDomainQuery(baseOptions: Apollo.QueryHookOptions<GetShopByShopDomainQuery, GetShopByShopDomainQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShopByShopDomainQuery, GetShopByShopDomainQueryVariables>(GetShopByShopDomainDocument, options);
      }
export function useGetShopByShopDomainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShopByShopDomainQuery, GetShopByShopDomainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShopByShopDomainQuery, GetShopByShopDomainQueryVariables>(GetShopByShopDomainDocument, options);
        }
export function useGetShopByShopDomainSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetShopByShopDomainQuery, GetShopByShopDomainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetShopByShopDomainQuery, GetShopByShopDomainQueryVariables>(GetShopByShopDomainDocument, options);
        }
export type GetShopByShopDomainQueryHookResult = ReturnType<typeof useGetShopByShopDomainQuery>;
export type GetShopByShopDomainLazyQueryHookResult = ReturnType<typeof useGetShopByShopDomainLazyQuery>;
export type GetShopByShopDomainSuspenseQueryHookResult = ReturnType<typeof useGetShopByShopDomainSuspenseQuery>;
export type GetShopByShopDomainQueryResult = Apollo.QueryResult<GetShopByShopDomainQuery, GetShopByShopDomainQueryVariables>;
export const GetShopPreferencesDocument = gql`
    query getShopPreferences($channelId: ID!) {
  shopByChannelId(channelId: $channelId) {
    preferences {
      purchaseFeedback {
        enabled
      }
      forceShopifyCheckout
    }
  }
}
    `;

/**
 * __useGetShopPreferencesQuery__
 *
 * To run a query within a React component, call `useGetShopPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShopPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShopPreferencesQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetShopPreferencesQuery(baseOptions: Apollo.QueryHookOptions<GetShopPreferencesQuery, GetShopPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShopPreferencesQuery, GetShopPreferencesQueryVariables>(GetShopPreferencesDocument, options);
      }
export function useGetShopPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShopPreferencesQuery, GetShopPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShopPreferencesQuery, GetShopPreferencesQueryVariables>(GetShopPreferencesDocument, options);
        }
export function useGetShopPreferencesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetShopPreferencesQuery, GetShopPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetShopPreferencesQuery, GetShopPreferencesQueryVariables>(GetShopPreferencesDocument, options);
        }
export type GetShopPreferencesQueryHookResult = ReturnType<typeof useGetShopPreferencesQuery>;
export type GetShopPreferencesLazyQueryHookResult = ReturnType<typeof useGetShopPreferencesLazyQuery>;
export type GetShopPreferencesSuspenseQueryHookResult = ReturnType<typeof useGetShopPreferencesSuspenseQuery>;
export type GetShopPreferencesQueryResult = Apollo.QueryResult<GetShopPreferencesQuery, GetShopPreferencesQueryVariables>;
export const CheckoutCompletedDocument = gql`
    mutation checkoutCompleted($shopId: ID!, $saleId: ID!, $orderId: ShopifyOrderID!) {
  checkoutCompleted(shopId: $shopId, saleId: $saleId, orderId: $orderId)
}
    `;
export type CheckoutCompletedMutationFn = Apollo.MutationFunction<CheckoutCompletedMutation, CheckoutCompletedMutationVariables>;

/**
 * __useCheckoutCompletedMutation__
 *
 * To run a mutation, you first call `useCheckoutCompletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutCompletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutCompletedMutation, { data, loading, error }] = useCheckoutCompletedMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      saleId: // value for 'saleId'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useCheckoutCompletedMutation(baseOptions?: Apollo.MutationHookOptions<CheckoutCompletedMutation, CheckoutCompletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckoutCompletedMutation, CheckoutCompletedMutationVariables>(CheckoutCompletedDocument, options);
      }
export type CheckoutCompletedMutationHookResult = ReturnType<typeof useCheckoutCompletedMutation>;
export type CheckoutCompletedMutationResult = Apollo.MutationResult<CheckoutCompletedMutation>;
export type CheckoutCompletedMutationOptions = Apollo.BaseMutationOptions<CheckoutCompletedMutation, CheckoutCompletedMutationVariables>;
export const TrackCartUpdateDocument = gql`
    mutation trackCartUpdate($shopId: ID!, $saleId: ID!, $productId: ShopifyProductID!, $variantId: ShopifyProductVariantID!, $quantity: Int!) {
  trackCartUpdate: productsAddedToCart(
    shopId: $shopId
    saleId: $saleId
    productId: $productId
    variantId: $variantId
    quantity: $quantity
  )
}
    `;
export type TrackCartUpdateMutationFn = Apollo.MutationFunction<TrackCartUpdateMutation, TrackCartUpdateMutationVariables>;

/**
 * __useTrackCartUpdateMutation__
 *
 * To run a mutation, you first call `useTrackCartUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackCartUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackCartUpdateMutation, { data, loading, error }] = useTrackCartUpdateMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      saleId: // value for 'saleId'
 *      productId: // value for 'productId'
 *      variantId: // value for 'variantId'
 *      quantity: // value for 'quantity'
 *   },
 * });
 */
export function useTrackCartUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TrackCartUpdateMutation, TrackCartUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrackCartUpdateMutation, TrackCartUpdateMutationVariables>(TrackCartUpdateDocument, options);
      }
export type TrackCartUpdateMutationHookResult = ReturnType<typeof useTrackCartUpdateMutation>;
export type TrackCartUpdateMutationResult = Apollo.MutationResult<TrackCartUpdateMutation>;
export type TrackCartUpdateMutationOptions = Apollo.BaseMutationOptions<TrackCartUpdateMutation, TrackCartUpdateMutationVariables>;
export const ActiveSaleUpdatedDocument = gql`
    subscription activeSaleUpdated($shopId: ID!) {
  activeSaleUpdated(shopId: $shopId) {
    ...SaleFields
  }
}
    ${SaleFieldsFragmentDoc}`;

/**
 * __useActiveSaleUpdatedSubscription__
 *
 * To run a query within a React component, call `useActiveSaleUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useActiveSaleUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveSaleUpdatedSubscription({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useActiveSaleUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<ActiveSaleUpdatedSubscription, ActiveSaleUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ActiveSaleUpdatedSubscription, ActiveSaleUpdatedSubscriptionVariables>(ActiveSaleUpdatedDocument, options);
      }
export type ActiveSaleUpdatedSubscriptionHookResult = ReturnType<typeof useActiveSaleUpdatedSubscription>;
export type ActiveSaleUpdatedSubscriptionResult = Apollo.SubscriptionResult<ActiveSaleUpdatedSubscription>;
export const SaleActivatedOrDeactivatedDocument = gql`
    subscription saleActivatedOrDeactivated($shopId: ID!) {
  saleActivatedOrDeactivated(shopId: $shopId) {
    ...ShopFields
  }
}
    ${ShopFieldsFragmentDoc}`;

/**
 * __useSaleActivatedOrDeactivatedSubscription__
 *
 * To run a query within a React component, call `useSaleActivatedOrDeactivatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSaleActivatedOrDeactivatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSaleActivatedOrDeactivatedSubscription({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useSaleActivatedOrDeactivatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<SaleActivatedOrDeactivatedSubscription, SaleActivatedOrDeactivatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SaleActivatedOrDeactivatedSubscription, SaleActivatedOrDeactivatedSubscriptionVariables>(SaleActivatedOrDeactivatedDocument, options);
      }
export type SaleActivatedOrDeactivatedSubscriptionHookResult = ReturnType<typeof useSaleActivatedOrDeactivatedSubscription>;
export type SaleActivatedOrDeactivatedSubscriptionResult = Apollo.SubscriptionResult<SaleActivatedOrDeactivatedSubscription>;
export const ShopConnectionForChannelUpdatedDocument = gql`
    subscription shopConnectionForChannelUpdated($channelId: ID!) {
  shopConnectionForChannelUpdated(channelId: $channelId) {
    ...ShopFields
  }
}
    ${ShopFieldsFragmentDoc}`;

/**
 * __useShopConnectionForChannelUpdatedSubscription__
 *
 * To run a query within a React component, call `useShopConnectionForChannelUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useShopConnectionForChannelUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopConnectionForChannelUpdatedSubscription({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useShopConnectionForChannelUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<ShopConnectionForChannelUpdatedSubscription, ShopConnectionForChannelUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ShopConnectionForChannelUpdatedSubscription, ShopConnectionForChannelUpdatedSubscriptionVariables>(ShopConnectionForChannelUpdatedDocument, options);
      }
export type ShopConnectionForChannelUpdatedSubscriptionHookResult = ReturnType<typeof useShopConnectionForChannelUpdatedSubscription>;
export type ShopConnectionForChannelUpdatedSubscriptionResult = Apollo.SubscriptionResult<ShopConnectionForChannelUpdatedSubscription>;
export const OrderCreatedForCartDocument = gql`
    subscription orderCreatedForCart($cartIds: [ID!]!) {
  orderCreatedForCart(cartIds: $cartIds) {
    ...OrderCreatedFields
  }
}
    ${OrderCreatedFieldsFragmentDoc}`;

/**
 * __useOrderCreatedForCartSubscription__
 *
 * To run a query within a React component, call `useOrderCreatedForCartSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOrderCreatedForCartSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderCreatedForCartSubscription({
 *   variables: {
 *      cartIds: // value for 'cartIds'
 *   },
 * });
 */
export function useOrderCreatedForCartSubscription(baseOptions: Apollo.SubscriptionHookOptions<OrderCreatedForCartSubscription, OrderCreatedForCartSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OrderCreatedForCartSubscription, OrderCreatedForCartSubscriptionVariables>(OrderCreatedForCartDocument, options);
      }
export type OrderCreatedForCartSubscriptionHookResult = ReturnType<typeof useOrderCreatedForCartSubscription>;
export type OrderCreatedForCartSubscriptionResult = Apollo.SubscriptionResult<OrderCreatedForCartSubscription>;
export const ViewerSignalledReturnToShowDocument = gql`
    subscription viewerSignalledReturnToShow($ids: [ID!]!) {
  viewerSignalledReturnToShow(ids: $ids) {
    id
  }
}
    `;

/**
 * __useViewerSignalledReturnToShowSubscription__
 *
 * To run a query within a React component, call `useViewerSignalledReturnToShowSubscription` and pass it any options that fit your needs.
 * When your component renders, `useViewerSignalledReturnToShowSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerSignalledReturnToShowSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useViewerSignalledReturnToShowSubscription(baseOptions: Apollo.SubscriptionHookOptions<ViewerSignalledReturnToShowSubscription, ViewerSignalledReturnToShowSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ViewerSignalledReturnToShowSubscription, ViewerSignalledReturnToShowSubscriptionVariables>(ViewerSignalledReturnToShowDocument, options);
      }
export type ViewerSignalledReturnToShowSubscriptionHookResult = ReturnType<typeof useViewerSignalledReturnToShowSubscription>;
export type ViewerSignalledReturnToShowSubscriptionResult = Apollo.SubscriptionResult<ViewerSignalledReturnToShowSubscription>;